import { Comment } from '../../types/prospect';
import { TaggedLender } from './lenderData';

export type Stage = 'pipeline' | 'credit_evaluation' | 'active_portfolio';
export type CreditRating = string;
export type PipelineStatus = string;
export type LoginStatus = 'Active' | 'Inactive' | 'Pending';
export type DocumentStatus = string;
export type Priority = 'High' | 'Medium' | 'Low' | '-';

export interface Interaction {
  id: string;
  comment: string;
  timestamp: Date;
  user: string;
}

export interface LeadRecord {
  id: string;
  companyLogo: string;
  companyName: string;
  leadRM: number;
  relationshipManager: string;
  partnerCompanyName: string;
  rating: CreditRating;
  city: string
  productTypeList: string[];
  dealSize: number;
  mraStatus: DocumentStatus;
  termSheetStatus: DocumentStatus;
  status: string;
  pipeline: PipelineStatus;
  statusId?: string;
  loginStatus: LoginStatus;
  createdDate: string;
  next_follow_up_date?: Date;
  stage: Stage;
  source?: string;
  customerName?: string;
  designation?: string;
  phone?: string;
  email?: string;
  comments: Comment[] | []
  lenders?: TaggedLender[];
  disbursements?: number;
  sanctionAmount?: number;
}


const afLeads = ['Amit Patel', 'Neha Gupta', 'Vikram Singh', 'Pooja Mehta', 'Rajesh Kumar'];
const relationshipManagers = ['Sarah Johnson', 'Michael Chen', 'Priya Sharma', 'James Wilson', 'Emma Davis'];
const partnerOwners = ['Rahul Verma', 'Anita Desai', 'Suresh Iyer', 'Kavita Nair', 'Deepak Joshi'];
const cities = ['Mumbai', 'Delhi', 'Bangalore', 'Chennai', 'Hyderabad', 'Pune', 'Kolkata'];
const productTypes = ['Equipment Lease', 'Vehicle Finance', 'Working Capital', 'Term Loan', 'Trade Finance', 'Asset Finance', 'Invoice Discounting'];
const creditRatings: CreditRating[] = ['AAA', 'AA', 'A', 'BBB', 'BB', 'B'];
const pipelineStatuses: PipelineStatus[] = ['New Lead', 'Contacted', 'Proposal Sent', 'Negotiation', 'Approved', 'Rejected', 'On Hold'];
const loginStatuses: LoginStatus[] = ['Active', 'Inactive', 'Pending'];
const stages: Stage[] = ['pipeline', 'credit_evaluation', 'active_portfolio'];
const documentStatuses: DocumentStatus[] = ['Pending', 'Signed'];
const priorities: Priority[] = ['High', 'Medium', 'Low'];



// Export arrays for filter options
export { afLeads, relationshipManagers, partnerOwners, cities, productTypes, pipelineStatuses, loginStatuses, priorities };
